// extracted by mini-css-extract-plugin
export default {"container":"CategoryHeader_container__aCxs9","subtitleContainer":"CategoryHeader_subtitleContainer__KcKM3","arrow":"CategoryHeader_arrow__O-Kdm"};